import SearchBar from 'components/SearchBar/SearchBar';
import BaseMultiDropdown from 'features/components/BaseMultiDropdown';
import { Form } from 'react-bootstrap';

export default function DeviceAssociationsSection({
  sectionCardClass,
  isCompactLayout,
  deviceSearchValue,
  setDeviceSearchValue,
  hasSelectedAudio,
  groupedDeviceAssociationOptions,
  selectedDevices,
  canEditDeviceAssociations,
  onToggleAssociatedDevice,
}) {
  const renderAssociationDeviceRow = (device, { itemIndex }) => {
    const isSelected = selectedDevices.includes(device.value);

    return (
      <div
        key={`device-${device.value}`}
        className={`d-flex align-items-center gap-2 px-3 py-2 border-top border-light border-opacity-10 ${
          itemIndex % 2 ? 'bg-primary' : 'bg-primary-shadow'
        } ${isSelected ? 'shadow-sm' : ''} ${
          canEditDeviceAssociations ? 'cursor-pointer' : 'cursor-not-allowed opacity-75'
        }`}
        onClick={() => onToggleAssociatedDevice(device.value)}
      >
        <Form.Check
          type="checkbox"
          readOnly
          checked={isSelected}
          disabled={!canEditDeviceAssociations}
        />
        <div
          className={`text-truncate flex-grow-1 ${
            canEditDeviceAssociations ? '' : 'text-white-50'
          }`}
          style={{ minWidth: 0 }}
        >
          {device.label || 'Unnamed Device'}
        </div>
      </div>
    );
  };

  return (
    <div className={sectionCardClass}>
      <div className="d-flex align-items-center justify-content-between bg-primary px-3 py-2 border-bottom border-secondary">
        <span className="fw-semibold">Device associations</span>
      </div>
      <div
        className={`min-h-0 p-3 pt-2 ${
          isCompactLayout ? 'd-flex flex-column overflow-hidden' : 'd-flex flex-column flex-grow-1'
        }`}
        style={isCompactLayout ? { maxHeight: '18rem' } : undefined}
      >
        <SearchBar
          className="mb-2 flex-shrink-0 min-width-0"
          inputClassName="text-white"
          placeholder="Search alarm devices"
          value={deviceSearchValue}
          onChange={setDeviceSearchValue}
          includeClear
          disabled={!hasSelectedAudio}
        />
        {!hasSelectedAudio && (
          <div className="text-muted small mb-2">
            Select an audio first to choose device associations.
          </div>
        )}
        <BaseMultiDropdown
          groups={groupedDeviceAssociationOptions}
          showGroupHeaders={false}
          emptyMessage="No alarm devices found."
          getDefaultActiveKeys={(group) => (group?.sections || []).map((section) => section.id)}
          renderItem={renderAssociationDeviceRow}
          getItemKey={(device) => device.value}
          containerClassName="d-flex flex-column gap-2 bg-primary rounded-3 border border-light border-opacity-25 p-2 flex-grow-1 min-h-0 overflow-y-auto overflow-x-hidden"
          sectionBodyClassName="bg-transparent p-0"
        />
      </div>
    </div>
  );
}
